var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Component } from 'react';
import { formDataLayer, formDataLayerGA4 } from '@anwb/data-layer';
import { FormContext } from '@anwb/form';
import { FormBlockContext } from '@anwb/form-block';
import { FormContainerFieldContext } from '@anwb/form-container-field';
import { generateValidationMessage, registerComponentHelper } from '@anwb/form-helpers';
import { Input } from '@anwb/forms';
/**
 * The Form Input component can be used to render an input with validation and transformation logic
 */
class FormInput extends Component {
    constructor(props) {
        super(props);
        /**
         * A set of default validation messages which are used
         */
        this.textValidationMessages = {
            badInput: 'Je hebt dit veld onjuist ingevuld.',
            customError: '',
            patternMismatch: 'Je hebt dit veld onjuist ingevuld.',
            rangeOverflow: 'De waarde die je in dit veld hebt ingevuld is te hoog.',
            rangeUnderflow: 'De waarde die je in dit veld hebt ingevuld is te laag.',
            stepMismatch: 'Je hebt dit veld onjuist ingevuld.',
            tooLong: 'De waarde die je in dit veld hebt ingevuld is te lang.',
            tooShort: 'De waarde die je in dit veld hebt ingevuld is te kort.',
            typeMismatch: 'Je hebt dit veld onjuist ingevuld.',
            valueMissing: 'Je hebt dit veld nog niet ingevuld.',
            valid: '',
        };
        this.state = {
            value: this.props.value || '',
            valid: undefined,
            elementValueHasBeenChanged: false,
            usePattern: !this.props.value ||
                this.props.value.length === 0 ||
                (this.props.pattern && new RegExp(this.props.pattern).test(this.props.value))
                ? this.props.pattern
                : undefined,
        };
        this.handlerChange = (element) => {
            const { name, handlerChange, handlerTransformationEndpoint } = this.props;
            if (handlerChange) {
                const value = handlerTransformationEndpoint
                    ? handlerTransformationEndpoint(element.value)
                    : element.value;
                handlerChange({
                    name,
                    valid: element.validity.valid,
                    value,
                });
            }
        };
        this.handlerChangedElementValue = (element) => {
            const { value, pattern } = this.props;
            const elementValueHasBeenChanged = value !== element.value;
            if (elementValueHasBeenChanged) {
                this.setState({
                    elementValueHasBeenChanged,
                    usePattern: pattern,
                });
            }
        };
        this.handlerValidPrefilledElement = (element) => {
            const { handlerValidation, handlerTransformationVisual } = this.props;
            const { usePattern } = this.state;
            if (handlerValidation && handlerTransformationVisual) {
                return handlerTransformationVisual(element.value).then((value) => this.setState({ value }));
            }
            if (usePattern && handlerTransformationVisual) {
                return handlerTransformationVisual(element.value).then((value) => this.setState({ value }));
            }
            return undefined;
        };
        this.onFocus = () => { };
        this.onInput = (element) => {
            this.handlerChangedElementValue(element);
            this.setState({ value: element.value, valid: undefined }, () => {
                if (element.validity.customError) {
                    element.setCustomValidity('');
                }
                if (element.validity.valid) {
                    this.validityHide();
                }
                this.validityCheckDynamic(element);
            });
        };
        this.onBlur = (element) => {
            const { handlerValidation } = this.props;
            if (element.value.length === 0) {
                this.validityReset();
                this.validityHide();
                if (handlerValidation) {
                    this.handlerChange(element);
                }
            }
            else {
                const analytics = true;
                this.setState({ value: element.value.trim(), valid: undefined }, () => {
                    this.validityCheck(element).then(() => {
                        this.validitySet(element, true);
                        this.validityShow(element, analytics);
                    });
                });
            }
        };
        this.onValidation = () => {
            const { executeSubmit, name, handlerTransformationEndpoint } = this.props;
            const analytics = !this.element.validity.valid;
            return this.validityCheck(this.element).then(() => {
                this.validitySet(this.element, true);
                this.validityShow(this.element, analytics);
                const value = handlerTransformationEndpoint
                    ? handlerTransformationEndpoint(this.state.value)
                    : this.state.value;
                return executeSubmit({ [name]: value || undefined });
            });
        };
        this.validityCheck = (element) => {
            const { handlerValidation, handlerTransformationVisual, valid } = this.props;
            const { elementValueHasBeenChanged } = this.state;
            const onSuccessfulValidation = () => {
                if (handlerTransformationVisual && element.value) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handlerTransformationVisual(element.value).then((value) => this.setState({ value }));
                }
            };
            // If a validity status was passed down through the props by a  parent
            // component we prioritise it and don't perform any other checks.
            if (valid !== undefined) {
                if (valid === true) {
                    onSuccessfulValidation();
                }
                else {
                    element.setCustomValidity(' ');
                }
                return Promise.resolve();
            }
            // Perform a normal validity check.
            if (elementValueHasBeenChanged && element.validity.valid && element.value) {
                if (handlerValidation) {
                    return handlerValidation(element.value, element)
                        .then(() => {
                        onSuccessfulValidation();
                    })
                        .catch((reason) => {
                        element.setCustomValidity(reason);
                    });
                }
                // Since there was no handlerValidation provided, we'll just treat
                // it as if the input value is correct.
                onSuccessfulValidation();
            }
            return Promise.resolve();
        };
        this.validityCheckDynamic = (element) => {
            const { handlerValidation, handlerValidationDynamic } = this.props;
            if (element.validity.valid && element.value && handlerValidationDynamic) {
                handlerValidationDynamic(element.value, element)
                    .then(() => {
                    this.handlerChange(element);
                })
                    .catch((reason) => {
                    element.setCustomValidity(reason);
                    this.validitySet(element, true);
                    this.validityShow(element);
                });
            }
            else if (!handlerValidation) {
                this.handlerChange(element);
            }
        };
        this.validitySet = (element, callHandlerChange) => {
            this.setState({ valid: element.validity.valid }, () => {
                if (callHandlerChange) {
                    this.handlerChange(element);
                }
            });
        };
        this.validityReset = () => {
            this.setState({ valid: undefined });
        };
        this.validityShow = (element, analytics) => {
            const { componentName, name, handlerValidationMessage, customTaggingEvent } = this.props;
            const { text, type } = generateValidationMessage(element, this.textValidationMessages);
            if (analytics) {
                const label = element.validity.valid ? 'valid' : `invalid-${type}-${text}`;
                formDataLayer({
                    type: 'interaction',
                    category: 'Formulier velden',
                    action: `${componentName || ''} ${name || ''}`,
                    label,
                });
                if (customTaggingEvent) {
                    customTaggingEvent(label);
                }
                else {
                    formDataLayerGA4({
                        event: 'user_interaction',
                        type: 'form',
                        component: componentName,
                        field: `form-field${name && `-${name}`}`,
                        action: 'change',
                        actionValue: label,
                    });
                }
            }
            if (!element.validity.valid && handlerValidationMessage) {
                handlerValidationMessage(text);
            }
        };
        this.validityHide = () => {
            const { handlerValidationMessage } = this.props;
            if (handlerValidationMessage)
                handlerValidationMessage('');
        };
        this.componentDidMount = () => {
            const { reference, textValidationMessages, registerComponent, value } = this.props;
            registerComponentHelper(registerComponent, {
                reference,
                validation: this.onValidation,
            });
            Object.assign(this.textValidationMessages, textValidationMessages);
            if (value && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                this.handlerValidPrefilledElement(this.element);
            }
        };
        this.componentWillUnmount = () => {
            const { unRegisterComponent, handlerState, name, reference } = this.props;
            unRegisterComponent(reference);
            if (handlerState && name)
                handlerState({ [name]: undefined });
        };
        this.componentDidUpdate = (_, prevState) => {
            const { value, valid } = this.state;
            if (value !== prevState.value || valid !== prevState.valid) {
                this.handlerState(value);
            }
        };
        // TODO: This lifecycle method is deprecated and should be removed:
        // https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
        // eslint-disable-next-line camelcase
        this.UNSAFE_componentWillReceiveProps = (nextProps) => {
            const currentProps = this.props;
            const hasValueChanged = currentProps.value !== nextProps.value;
            const hasRequiredChanged = currentProps.required !== nextProps.required;
            const hasPatternChanged = currentProps.pattern !== nextProps.pattern;
            const hasValidChanged = currentProps.valid !== nextProps.valid;
            if (hasValueChanged || hasRequiredChanged || hasPatternChanged || hasValidChanged) {
                this.setState((currentState) => ({
                    value: hasValueChanged ? nextProps.value || '' : currentState.value,
                    valid: undefined,
                    elementValueHasBeenChanged: hasValueChanged || hasValidChanged,
                    usePattern: nextProps.pattern,
                }), () => {
                    if (this.element.validity.customError) {
                        this.element.setCustomValidity('');
                    }
                    if (this.element.validity.valid) {
                        this.validityHide();
                    }
                    if (this.state.value) {
                        this.validityCheck(this.element).then(() => {
                            this.validitySet(this.element, true);
                            this.validityShow(this.element);
                        });
                    }
                    else {
                        this.validityReset();
                        this.validityHide();
                        this.handlerChange(this.element);
                    }
                });
            }
        };
        if (this.props.value !== undefined && this.props.value !== null) {
            this.handlerState(this.props.value);
        }
    }
    handlerState(value) {
        const { name, handlerState, handlerTransformationEndpoint } = this.props;
        if (handlerState && name) {
            const nextValue = handlerTransformationEndpoint
                ? handlerTransformationEndpoint(value)
                : value;
            handlerState({
                [name]: value.length > 0 ? nextValue : undefined,
            });
        }
    }
    componentWillReceiveProps(value) {
        this.UNSAFE_componentWillReceiveProps(value);
    }
    render() {
        const _a = this.props, { type = 'text', reference = 'form-input', name = 'input', placeholder, maxlength, autocomplete = 'off', required = false, disabled = false, loading = false, componentName = 'form-input', onFocus, onInput, onBlur, handlerState, handlerValidation, handlerValidationMessage, handlerTransformationVisual, textValidationMessages = {}, changeEvent = 'onInput', dataTest } = _a, props = __rest(_a, ["type", "reference", "name", "placeholder", "maxlength", "autocomplete", "required", "disabled", "loading", "componentName", "onFocus", "onInput", "onBlur", "handlerState", "handlerValidation", "handlerValidationMessage", "handlerTransformationVisual", "textValidationMessages", "changeEvent", "dataTest"]);
        const { valid, value, usePattern } = this.state;
        const extraProps = {
            [changeEvent]: (event) => {
                this.onInput(this.element);
                if (onInput)
                    onInput(event);
            },
        };
        return (React.createElement(Input, Object.assign({}, props, { ref: (element) => {
                if (element)
                    this.element = element;
            }, reference: reference, valid: valid !== false, type: type, name: name, placeholder: placeholder, value: value, pattern: usePattern, maxLength: maxlength, autoComplete: autocomplete, required: required, disabled: disabled, loading: loading, "data-test": dataTest }, (value && { value: String(value) }), { "aria-labelledby": `${reference || ''}-label ${reference || ''}-error-area`, onFocus: (event) => {
                this.onFocus();
                if (onFocus)
                    onFocus(event);
            }, onBlur: (event) => {
                this.onBlur(this.element);
                if (onBlur)
                    onBlur(event);
            } }, extraProps)));
    }
}
// Chrome ignores autocomplete off, workaround is to set autocomplete
// to randomly chosen value in form fields. Therefore autocomplete
// is set to 'do-not-autofill' for form fields when autocompletion is disabled
// https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill#demo
// https://caniuse.com/input-autocomplete-onoff
const FormInputWithContext = (props) => (React.createElement(FormContext.Consumer, null, ({ registerComponent, unRegisterComponent, executeSubmit, autocompletion }) => (React.createElement(FormBlockContext.Consumer, null, ({ handlerState }) => (React.createElement(FormContainerFieldContext.Consumer, null, ({ handlerValidationMessage }) => (React.createElement(FormInput, Object.assign({}, props, { registerComponent: registerComponent, unRegisterComponent: unRegisterComponent, executeSubmit: executeSubmit, handlerState: handlerState, handlerValidationMessage: handlerValidationMessage, autocomplete: autocompletion === 'off' ? 'do-not-autofill' : undefined })))))))));
export default FormInputWithContext;
//# sourceMappingURL=FormInput.js.map